<!--
Author: TangChen
Date: 2018-11-06
Desc: CRS信息，由index.js 配置引入
-->
<template>
    <div class="crs-box">
        <comp-title-dc back-url-name="taxeslist">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/info' }">个人中心</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/info' }">信息中心</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/info/taxeslist' }">
                    CRS信息录入
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title-dc>
        <div class="title">{{ title }}</div>
        <div :class="'bizcomp-taxes-info bizcomp ' + className">
            <crs-info />
        </div>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import crsInfo from "@/components/acctInfo/crsInfo.vue";
export default {
    name: "TaxesInfo",
    components: {
        crsInfo
    },
    mixins: [mixin],
    data() {
        return {};
    },
    methods: {}
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
/*用户信息 */
.crs-box {
    .title {
        margin: 17px 19px;
        font-size: 20px;
        font-weight: 500;
        color: #333333;
    }
}
.bizcomp-taxes-info {
}
</style>
